var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBaseball(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICON_Baseball") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON_Baseball",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_baseball_177864_000000",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,8.99914281 C13,11.7615721 10.7615721,14 8.00085719,14 C5.23842791,14 3,11.7615721 3,8.99914281 C3,6.23838505 5.23842791,4 8.00085719,4 C10.7616149,4 13,6.23842791 13,8.99914281",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4,1.6 C38.2666667,-0.533333333 34.88832,-0.533333333 32.7549867,1.6 C31.689984,2.66666667 22.4450133,12.8 14,22.7549867 L19.2450133,28 C29.11168,19.5549867 39.3333333,10.31168 40.4,9.24501333 C42.5333333,7.110016 42.5333333,3.73333333 40.4,1.6 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9960633,25 C8.6003219,29.0001004 5.47433567,32.8218496 3.23952785,35.8452855 L2.79222319,35.400261 C2.16736904,34.7785921 1.09521023,34.7785921 0.468640616,35.400261 C-0.156213539,36.02193 -0.156213539,37.0886234 0.468640616,37.711999 L1.27443229,38.5103551 L3.41874991,40.643742 L4.22286902,41.5337483 C4.84772318,42.1554172 5.91988199,42.1554172 6.5464516,41.5337483 C7.17130575,40.9120794 7.17130575,39.8453859 6.5464516,39.2220103 L6.09914694,38.7769858 C9.13635842,36.4652478 12.9794045,33.3551964 17,30.0650871 L11.9960633,25 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseball);
export default ForwardRef;